import { getMentionVerifyMatchTargetFromMention } from '@app/modules/audit/modules/station-audit/components/verify-match/to-verify-match-target';
import { useVerifyMatchListDialog } from '@app/modules/audit/modules/station-audit/components/verify-match/useVerifyMatchListDialog';
import { VerifyMatchListDialog } from '@app/modules/audit/modules/station-audit/components/verify-match/VerifyMatchListDialog';
import { MrtTable } from '@mi-front/ui';
import { Alert } from '@mui/material';
import { isToday, parseISO } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import { ListingResultProps } from '../../../../../../../../core/reports/components/ListingView';
import { useReportCtx } from '../../../../../../../../core/reports/report-ctx';
import { MentionsMatchesListing } from './types';
import { useMentionsMatchesColumns } from './useMentionsMatchesColumns';

/**
 * Live-mentions matches table with verify-match dialog navigation.
 */
export function MentionsMatchesList(p: ListingResultProps<MentionsMatchesListing>) {
  const { values, refreshReport } = useReportCtx<MentionsMatchesListing>();
  const showProcessEndDateMsg = isToday(parseISO(values.from)) && isToday(parseISO(values.to));

  const { openAt, onDisplayRowsChange, dialogProps } = useVerifyMatchListDialog(
    getMentionVerifyMatchTargetFromMention,
    refreshReport,
  );
  const columns = useMentionsMatchesColumns({ openAt });

  if (showProcessEndDateMsg) {
    return (
      <Alert severity={'warning'}>
        <FormattedMessage
          id="audit.liveMentions.processingMessage"
          defaultMessage="Las menciones en vivo se están procesando. Los resultados estarán disponibles en breve."
        />
      </Alert>
    );
  }

  return (
    <>
      <MrtTable
        {...p.mrtProps}
        enableTopToolbar={false}
        onDisplayRowsChange={onDisplayRowsChange}
        columns={columns}
      />
      <VerifyMatchListDialog dialogProps={dialogProps} />
    </>
  );
}
